import { AirUrlParams } from 'hooks/useAirNavigation';
import * as SliderWithId from 'types/_general/Search/SliderWithId';

export type Type = SliderWithId.Type[];

export function create(): Type {
	return [];
}

export function mapToApi(obj: Type): {
	priceRange: { minimum: number | null; maximum: number | null };
	carbonDioxideRange: { minimum: number | null; maximum: number | null };
} {
	const priceSlider = obj.find((x) => x.id === 'price');
	const co2Slider = obj.find((x) => x.id === 'co2');
	return {
		priceRange: { minimum: priceSlider?.left ?? null, maximum: priceSlider?.right ?? null },
		carbonDioxideRange: { minimum: co2Slider?.left ?? null, maximum: co2Slider?.right ?? null },
	};
}

export function mapToApiOld(obj: Type): {
	priceRange?: { minimum: number; maximum: number };
	carbonDioxideRange?: { minimum: number; maximum: number };
} {
	let output = {};
	obj.forEach((x) => {
		if (x.id === 'price')
			output = { ...output, priceRange: { minimum: x.left, maximum: x.right } };
		if (x.id === 'co2')
			output = { ...output, carbonDioxideRange: { minimum: x.left, maximum: x.right } };
	});
	return { ...output };
}

export function mapToUrl(obj: Type): string {
	const array: string[] = [];
	obj.forEach((x) => {
		array.push(`${x.id}:${x.left}:${x.right}`);
	});
	return array.join(';');
}

export function mapFromUrl(params: AirUrlParams, urlKey: string): Type {
	const output: Type = [];
	const urlList: string | undefined = params[urlKey];

	if (!urlList) return output;

	const temp: string[] = urlList.split(';');

	temp.forEach((x) => {
		const split = x.split(':');
		output.push({
			id: split[0],
			left: Number(split[1]),
			right: Number(split[2]),
		});
	});

	return output;
}

export function getById(obj: Type, id: string): SliderWithId.Type {
	const output = obj.find((x) => x.id === id);
	if (output) return output;
	return SliderWithId.create();
}
